// 제품 등록 모달 - 모달을 여는 함수
function openProductRegisterModal() {

  let modalContent = `
		<div class="mypage-register-modal">
      <div class="mypage-register-modal-wrapper">
        <div class="body-1">

          <img class="img-product-ex m__b_28" src="${img_product_check_serial}" alt="img-product-ex" style="width: 100%; border-radius: 4px;">

          <div class="space__between m__b_28 check-serial-number-title" style="align-items: center;">
            <span>시리얼 넘버 확인 방법</span>
            <div class="check-serial-btn">
              <img 
                id="check-serial-number-toggle"
                class="icon_arrow_down_bk" 
                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'%3E%3Cpath d='M3.125 6.875L10 13.75L16.875 6.875' stroke='black' stroke-width='1.2' stroke-linecap='square'/%3E%3C/svg%3E"
                alt="icon-arrow-bk"
                onclick="checkSerialNumber()"
              />
            </div>
          </div>

          <div id="check-serial-number" class="m__t_12 m__b_44 gap__4 body-4 text-tertiary txt__dark_gry hidden">
            <img class="img-product-ex" src="${img_product_ex}" alt="img-product-ex" style="width: 100%; border-radius: 4px;">
            <div class="m__t_4 align__center">
              <div style="height: 24px;">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="24" viewBox="0 0 10 24" fill="none">
                  <circle cx="5.0001" cy="12" r="1.4" fill="#7C8084"/>
                </svg>
              </div>
              <span>제품 하부에 부착된 품질표시 스티커에서 시리얼 넘버를 확인하세요.</span>
            </div>
            <div class="m__t_4">
              <div style="height: 24px;">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="24" viewBox="0 0 10 24" fill="none">
                  <circle cx="5.0001" cy="12" r="1.4" fill="#7C8084"/>
                </svg>
              </div>
              <p style="text-align:left;margin:0;">
                시리얼 넘버의 <span class="text-select">끝자리</span>는 숫자가 아니라 <span class="text-select">영문</span>입니다. 1과 I, 5와 S를 구분해서 입력해 주세요.
              </p>
            </div>
            <div class="m__t_4 align__center">
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="24" viewBox="0 0 10 24" fill="none">
                  <circle cx="5.0001" cy="12" r="1.4" fill="#7C8084"/>
                </svg>
              </div>
              <span style="text-align:left;">시리얼 넘버가 손상되었거나 확인이 불가능한 경우, 챗봇 또는 컨택센터로 문의 바랍니다.</span>
            </div>
          </div>

          <div class="serial-number-box m__b_32">
            <label class="label__user body-2 text-secondary" style="display: table-cell;"for="">시리얼 넘버(S/N)</label>
            <input class="popup_input m__t_4 m__b_6 body-2" type="text" id="display_name" placeholder="숫자+영문으로 구성되어 있습니다." oninput="checkButtonActivation()">
            <div class="body-4 text-error"></div>
          </div>

          <div class="add_product_check">

            <div class="body-4 space__between align__center">
              <div class="align__center cursor__pointer">
                <input type="checkbox" id="checkAll" class="regi_check_all cursor__pointer" />
                <label for="checkAll" class="cursor__pointer">전체 동의</label>
              </div>
            </div>

            <div style="width:100%; height:1px; background: #EAEDF0; margin: 4px 0px 4px 4px;"></div>

            <div class="body-4 space__between align__center txt__dark_gry hidden">
              <div class="align__center cursor__pointer">
                <input type="checkbox" id="individual_regi_check_service" class="checkIndividual regi_check_service cursor__pointer" />
                <label for="individual_regi_check_service" class="cursor__pointer"><span class="terms_txt text-select">(필수)</span><span class="check_txt"> 쇼핑몰 이용 약관</span></label>
              </div>
              <div class="btn_show text-tertiary show_terms_service" id="policy_1">보기</div>
            </div>

            <div class="body-4 space__between align__center txt__dark_gry">
              <div class="align__center cursor__pointer">
                <input type="checkbox" id="individual_regi_check_privacy" class="checkIndividual regi_check_privacy cursor__pointer" />
                <label for="individual_regi_check_privacy" class="cursor__pointer"><span class="terms_txt text-select">(필수)</span><span class="check_txt"> 개인정보 수집 및 이용 동의</span></label>
              </div>
              <div class="btn_show text-tertiary show_privacy_policy" id="policy_2">보기</div>
            </div>
          </div>

        </div>
      </div>
      <!-- 정책 -->
      <div class="policy-1" style="display : none">${shopTermsService}</div>
      <div class="policy-2" style="display : none">
        <div class="terms-modal-container">
          <div class="terms-modal-title">[필수] 개인정보 수집 및 이용 동의</div>
          <table>
            <thead>
              <tr>
                <th colspan="2">항목</th>
                <th>목적</th>
                <th>보유 및 이용 기간</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>필수</td>
                <td>이름, 이메일, 휴대폰 번호</td>
                <td>제품 정품등록, 제품별 맞춤형 콘텐츠 및 서비스 등 제공 또는 추천</td>
                <td>회원탈퇴 시</td>
              </tr>
            </tbody>
          </table>
          <div class="terms-modal-text">
            &#8251; 정보주체는 개인정보 수집 및 이용에 동의하지 않을 권리가 있으며, 선택 사항에 대한 동의를 거부하더라도 서비스 이용이 가능합니다.
          </div>
        </div>
      </div>
    </div>

    <div class="add_product_complete_wrapper">
      <div class="add_product_complete" onclick="addProductProceed()">정품 등록하기</div>
    </div>`;

  openModalWithContent("새로운 제품 등록하기", modalContent, function () {

    // document.getElementById("site-alert-modal").classList.add("register-modal");
    // document.querySelector('.register-modal .modal--close_btn').addEventListener('click', handleRegisterClose);

    checkAllBoxInput();
    // modalTermsService();
    // modalPrivacyPolicy();

    // 체크박스 상태 유지 관리
    // restoreCheckboxStateFromSession();
    // attachCheckboxListeners();

    let modalContents = document.querySelector('.modal--contents');
    modalContents.style.height = 'auto';
    modalContents.style.marginBottom = '100px';

    showPolicyRegister();
  });
}

// 제품 등록 모달 - 보기 버튼 클릭시
// mypage-register-modal-wrapper 안보이고 policy-num보여주기
function showPolicyRegister() {
  const modalWrapper = document.querySelector('.mypage-register-modal-wrapper');
  const modalHeader = document.querySelector('.modal--header');
  const modalButton = document.querySelector('.add_product_complete_wrapper');

  // 뒤로가기 버튼 생성 함수
  const createBackButton = () => {
    const backButton = document.createElement('button');
    backButton.innerHTML = `<span style="display:flex; padding: 4px;">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M9.1875 2.1875L4.375 7L9.1875 11.8125" stroke="white" stroke-width="1.2" stroke-linecap="square" style="mix-blend-mode:exclusion"/>
      </svg>
    </span>`;
    backButton.className = 'back-button';
    modalHeader.prepend(backButton); // modalHeader의 맨 앞에 추가
    return backButton;
  };

  const titleElement = modalHeader.querySelector('p'); // 텍스트를 변경할 요소

  // 정책 보기 버튼 동작
  [1, 2].forEach(num => {
    const button = document.querySelector(`#policy_${num}`);
    const policy = document.querySelector(`.policy-${num}`);

    // 버튼 클릭 시 동작
    button.addEventListener('click', () => {
      // .mypage-register-modal-wrapper 숨기기
      modalWrapper.style.display = 'none';
      modalButton.style.display = 'none';
      // 모든 정책 숨기기
      document.querySelectorAll('[class^="policy-"]').forEach(content => {
        content.style.display = 'none';
      });

      // 클릭된 정책만 표시
      policy.style.display = 'block';
      // policy.querySelector('.terms_container').style.width = '100%';
      // policy.querySelector('.terms_container').style.paddingBottom = '100px';
      // policy.querySelector('.terms_container .terms_body').style.padding = '0';
      // policy.querySelector('.terms_container .terms_body').style.paddingBottom = '60px';

      // 뒤로가기 버튼 생성 및 추가
      const backButton = createBackButton();

      // .title-7 텍스트 변경
      if (num === 1) {
        titleElement.textContent = '쇼핑몰 이용 약관';
      } else if (num === 2) {
        titleElement.textContent = '개인정보 수집 및 이용 동의';
      }

      // 뒤로가기 버튼 동작
      backButton.addEventListener('click', () => {
        // 정책 숨기기 및 모달 표시
        modalWrapper.style.display = 'block';
        document.querySelectorAll('[class^="policy-"]').forEach(content => {
          content.style.display = 'none';
        });

        // 뒤로가기 버튼 제거
        backButton.remove();
        modalButton.style.display = 'block';
        // .title-7 텍스트 초기화
        titleElement.textContent = '새로운 제품 등록하기';
      });

      const closeBtn = document.querySelector('.modal--close_btn');
      closeBtn.addEventListener('click', () => {
        backButton.remove();
      });
    });
  });
}

// 제품 등록 모달 - 시리얼 넘버 확인 방법 토글
function checkSerialNumber() {
  let check_serial_number = document.getElementById("check-serial-number");
  let toggle = document.getElementById("check-serial-number-toggle");
  let title = document.querySelector(".check-serial-number-title");

  if (check_serial_number) {

    check_serial_number.classList.toggle('hidden');

    if (check_serial_number.classList.contains('hidden')) {
      toggle.style.transform = "scale(1)";
      title.classList.add("m__b_28");
    }
    else {
      toggle.style.transform = "scale(-1)";
      title.classList.remove("m__b_28");
    }
  }
}

// 제품 등록 모달 - 체크 박스
function checkAllBoxInput() {
  const checkAll = document.getElementById("checkAll");
  const checkIndividualList = document.querySelectorAll(".checkIndividual.regi_check_privacy");

  // 모두 체크 버튼 클릭 이벤트
  checkAll.addEventListener("click", () => {
    checkIndividualList.forEach(checkIndividual => {
      checkIndividual.checked = checkAll.checked;
    });
    checkButtonActivation();
  });

  // 개별 체크박스 클릭 이벤트
  checkIndividualList.forEach(checkIndividual => {
    checkIndividual.addEventListener("change", () => {
      const isAllChecked = Array.from(checkIndividualList).every(check => check.checked);
      checkAll.checked = isAllChecked;
      checkButtonActivation();
    });
  });
}

// 제품 등록 모달 - 버튼 활성화
function checkButtonActivation() {

  let addButton = document.querySelector(".add_product_complete");

  let checkAll = document.getElementById("checkAll");
  let serialInput = document.querySelector(".serial-number-box input");
  const regex = /^[a-zA-Z0-9-]*$/;

  if (checkAll.checked && serialInput.value.trim() != "" && regex.test(serialInput.value.trim())) {
    addButton.classList.add("add_activation");
  }
  else {
    addButton.classList.remove("add_activation");
  }
}

// 제품 등록 모달 - 등록 버튼 클릭 API
function addProductProceed() {

  let serialInput = document.querySelector(".serial-number-box input");
  let errorText = document.querySelector(".serial-number-box .text-error");
  let checkAll = document.getElementById("checkAll");
  let addButton = document.querySelector(".add_product_complete");
  const regex = /^[a-zA-Z0-9-]*$/;

  if (!(checkAll.checked && serialInput.value.trim() != "" && regex.test(serialInput.value.trim()))) {
    return;
  }

  addButton.style.pointerEvents = 'none';

  fetch('https://sidiz-shopify.fursys.com/v1/db/serial-registration', {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      "customerMd5Hash": customerMd5Hash,
      "serial_number": serialInput.value.trim()
    })
  })
  .then(response => {
    if (!response.ok) {
      return response.json().then(errorData => {
        throw new Error(errorData.response_message);
      });
    }
    return response.json();
  })
  .then(data => {
    if(data.success && data.code == "200"){
      closeAlertModal();

      let completeModalContent = `
        <div class="mini-modal-center">
          <div class="mini-modal-text">
            제품이 등록되었습니다.
          </div>
          <div class="mini-modal-btn complete-modal-btn">확인</div>
        </div>
      `;

      openMiniModalWithContent(completeModalContent, function() {
        // document.getElementById("site-alert-modal").classList.remove("mobile-full-height");
        let btn = document.querySelector(".complete-modal-btn");
        btn.addEventListener('click', () => {
          closeMiniModal();
          history.go(0);
        })
      });
    }
    else{
      if(data.code == "500"){
        errorText.innerHTML = 
        `시스템 오류가 발생했습니다. 다시 시도해주세요.<br>
        문제가 지속될 경우, 챗봇 또는 컨택센터로 문의해 주시기 바랍니다.`;
      }
      else if(data.code == "501"){
        errorText.innerHTML = 
        `잘못된 시리얼 넘버입니다.<br>확인 후 다시 입력해 주세요<br>
        문제가 지속될 경우, 챗봇 또는 컨택센터로 문의해 주시기 바랍니다.`;
      }
      else if(data.code == "502"){
        errorText.innerHTML = 
        `품질보증 대상이 아니거나 기간이 만료된 제품입니다.<br> 챗봇 또는 컨택센터로 문의해 주시기 바랍니다.`;
      }
      else if(data.code == "503"){
        errorText.innerHTML = 
        //`네트워크 연결이 원활하지 않습니다.<br>
        `시스템 오류가 발생했습니다. 다시 시도해주세요.<br>
        문제가 지속될 경우, 챗봇 또는 컨택센터로 문의해 주시기 바랍니다.`;
      }
      
      else if(data.code == "1001" || data.code == "1002" || data.code == "1003"){
        errorText.innerHTML = data.msg;
      }
      else{
        errorText.innerHTML = `시스템 오류가 발생했습니다. 다시 시도해 주세요.<br>문제가 지속될 경우 챗봇 또는 컨택센터로 문의해 주시기 바랍니다.`;
      }
    }
  })
  .catch((error) => {
    errorText.innerHTML = 
        `시스템 오류가 발생했습니다. 다시 시도해 주세요.<br>문제가 지속될 경우 챗봇 또는 컨택센터로 문의해 주시기 바랍니다.`;
  })
  .finally(() => {
    addButton.style.pointerEvents = 'auto';
  })

  function closeOnlyMiniModal(){
    document.getElementById('site-mini-modal').classList.remove('active');
    document.querySelector('#site-mini-modal .mini-modal-contents').innerHTML = '';
  }
}

function handleTermsClose() {
  let addBtn = document.querySelector('#mypage_my_product .btn_add_product');
  addBtn.click();
  document.querySelector('.modal--close_btn').removeEventListener('click', handleTermsClose);
}

function handleRegisterClose() {
  removeCheckboxStateFromSession();
  document.querySelector('.modal--close_btn').removeEventListener('click', handleRegisterClose);
}

// 체크박스 상태 세션 스토리지에 저장
function saveCheckboxStateToSession() {
  sessionStorage.setItem('regi_check0', document.querySelector('.regi_check_all').checked);
  sessionStorage.setItem('regi_check1', document.querySelector('.regi_check_service').checked);
  sessionStorage.setItem('regi_check2', document.querySelector('.regi_check_privacy').checked);
}

// 체크박스 변경 이벤트 리스너 추가
function attachCheckboxListeners() {
  document.querySelector('.regi_check_all').addEventListener('change', saveCheckboxStateToSession);
  document.querySelector('.regi_check_service').addEventListener('change', saveCheckboxStateToSession);
  document.querySelector('.regi_check_privacy').addEventListener('change', saveCheckboxStateToSession);
}

// 세션 스토리지에서 상태 복원
function restoreCheckboxStateFromSession() {
  document.querySelector('.regi_check_all').checked = sessionStorage.getItem('regi_check0') === 'true';
  document.querySelector('.regi_check_service').checked = sessionStorage.getItem('regi_check1') === 'true';
  document.querySelector('.regi_check_privacy').checked = sessionStorage.getItem('regi_check2') === 'true';
}

// 체크박스 상태 세션 스토리지에서 지우기
function removeCheckboxStateFromSession() {
  sessionStorage.removeItem("regi_check0");
  sessionStorage.removeItem("regi_check1");
  sessionStorage.removeItem("regi_check2");
}